import { notify } from './actions';
import { actions } from './slice';

const allActions = {
  ...actions,
  notify,
};

export { allActions as notificationActions };
export { reducer } from './slice';
